import request from '@/utils/request';

export default {
  getActiveUsers (filter) {
    return request.get('api/admin/stat/activeuser', filter);
  },
  getNewUser (filter) {
    return request.get('api/admin/stat/newuser', filter);
  },
  getPayUser (filter) {
    return request.get('api/admin/stat/payuser', filter);
  },
  getPayUserTotal (filter) {
    return request.get('api/admin/stat/totalPay', filter);
  },
  getExpenseUser (filter) {
    return request.get('api/admin/stat/expenseuser', filter);
  },
  getTotalConsumeDiamond (filter) {
    return request.get('api/admin/stat/totalConsumeDiamond', filter);
  },
  getDiamond (filter) {
    return request.get('api/admin/stat/diamond', filter);
  },
  getArpu (filter) {
    return request.get('api/admin/stat/arpu', filter);
  },
  getArppu (filter) {
    return request.get('api/admin/stat/arppu', filter);
  }
};



// WEBPACK FOOTER //
// ./src/api/statistics.js